/**
 * Simple Shipping Utilities
 * 
 * Replaces the complex supplier-based shipping logic with a unified
 * 3-option shipping system.
 */

import {
  calculateShippingCost,
  getShippingZone,
  type ShippingOption,
  type ShippingZone
} from './shippingConfig';

/**
 * Calculate total shipping cost for an order
 */
export function calculateOrderShipping(
  option: ShippingOption,
  city: string,
  overrides?: { central?: number; remote?: number }
): { cost: number; zone: ShippingZone } {
  const zone = getShippingZone(city);
  const cost = calculateShippingCost(option, zone, overrides);

  return { cost, zone };
}

/**
 * Validate shipping option selection
 */
export function validateShippingSelection(
  option: ShippingOption | null,
  city: string | null
): { valid: boolean; message?: string } {
  if (!option) {
    return { valid: false, message: 'יש לבחור אופציית משלוח' };
  }

  if (option !== 'pickup' && !city) {
    return { valid: false, message: 'יש לבחור עיר למשלוח' };
  }

  return { valid: true };
}
